import React, { useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import logoLight from '../imgs/logo-light.png';
import logoDark from '../imgs/logo-dark.png';
import Hamburger from './Hamburger';
import { HeaderContainerStyled } from '../styles/Margin';
import { LogoStyled } from '../styles/Nav';
import { useNavigate } from 'react-router-dom'

function Header({ user, logOut, handleThemeChange, setFormStep }) {
    let [menuOpen, setMenuOpen] = useState(0);
    const navigate = useNavigate();
    const theme = useContext(ThemeContext);
    const logo = theme.name === 'dark-theme' ? logoLight : logoDark;
    
    const handleHomeClick = () => {
        setMenuOpen(0);
        setFormStep(0)
        navigate('/')
    }

    // Only show hamburger menu for verified users
    const showHamburger = user && user.emailVerified;
    
    return (
        <HeaderContainerStyled>
            <LogoStyled onClick={handleHomeClick} src={logo} alt='logo' className="desktop-logo" />
            {showHamburger ?
                <Hamburger 
                    user={user}
                    logOut={logOut}
                    // onNavClick={setActiveTab}
                    setFormStep={setFormStep}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    handleThemeChange={handleThemeChange}
                    logo={logo}
                    onLogoClick={handleHomeClick}
                />
                : null}
        </HeaderContainerStyled>
    );
}

export default Header